import { connect } from "react-redux";
import { PRODUCT_EXPERIENCES_WITH_HOTEL } from "app/constants";

import TravelDates from "app/pages/.shared/TravelDates/TravelDates";
import withRouter from "app/utils/hocs/withRouter";

const mapStateToProps = (state, ownProps) => {
	const pathname = ownProps.location.pathname;
	const isSDP = pathname.includes("/sdp");
	const currentMerchCode = state.merchandising?.current?.code;
	let booking = state.booking;
	const isWithHotel = PRODUCT_EXPERIENCES_WITH_HOTEL.includes(
		state?.ficheProduit?.productExperience
	);

	if (currentMerchCode && isSDP) {
		booking = state.booking.smartDPMerch;
	}

	return {
		booking,
		isWithHotel,
	};
};

export default withRouter(connect(mapStateToProps)(TravelDates));
